<template>
  <v-container class="pa-0 ma-0">
    <v-dialog v-model="dialog" fullscreen hide-overlay scrollable transition="dialog-bottom-transition" class="pa-0 ma-0">
      <v-card flat>
        <v-card-title>
          <span>Preview Ansicht</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false" color="black">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-img :src="dialogImage" contain max-height="100%" @click="dialog = false"></v-img>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="dialogImageisVertical" @click="download(offerImageUrlV, 'offer' + offerId + 'v.png')" icon><v-icon color="primary">cloud_download</v-icon></v-btn>
          <v-btn v-else @click="download(offerImageUrlH,'offer' + offerId + 'h.png')" icon><v-icon color="primary">cloud_download</v-icon></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row class="pa-4" v-if="checkURL">
      <v-col xs="8" sm="10">
        <v-text-field v-model="url" outlined label="Angebots-URL" clearable></v-text-field>
      </v-col>
      <v-col xs="4" sm="2">
        <v-btn @click="checkUrlParamsByUrl(url)" color="primary" dark>Prüfen</v-btn>
      </v-col>
    </v-row>
    <v-row class="pa-4" v-if="errorResponse">
      <v-col v-if="!errorResponse.company">
        <span>Büro mit der id {{errorResponse.agencyId}}-{{officeId}} konnte nicht identifiziert werden. </span><br>
        <br>
        <span style="font-size: 14px">
        Sie sind noch nicht freigeschaltet.<br><br>
        Bitte nehmen Sie Kontakt mit Kermax Support auf:<br>
        TEL: 0851-9888-30<br>
        E-Mail: <a ref="mailto:support@kermax.de">support@kermax.de</a><br>
        </span>
        <br>
        <v-img
            :src="require('../../../assets/logo2.png')"
            class="mt-3"
            contain
            height="800"
        ></v-img>
      </v-col>
    </v-row>
    <v-row class="pa-0 ma-0 justify-center" v-if="showStage">
      <v-col cols="12" xs="12" class="pa-4 text-center" v-if="!doneAdd">
        <v-card class="pa-4" flat>
          <v-card-text>
            <center>
              <table width="100%" style="" cellpadding="0" cellspacing="0">
                <tr>
                  <td height="290" style="min-height: 290px;" align="center" v-if="selectedDevicesH && selectedDevicesH.length > 0">
                    <v-img :src="offerImageUrlV" max-height="320" max-width="140" @click="preview(true,offerImageUrlV)"></v-img>
                    <v-btn @click="download(offerImageUrlV, 'offer' + offerId + 'v.png')" icon><v-icon color="primary">cloud_download</v-icon></v-btn>
                  </td>
                  <td height="290"  style="min-height: 290px;" align="center" v-else>
                  </td>
                  <td  height="290" style="min-height: 290px;" align="center" v-if="selectedDevicesV && selectedDevicesV.length > 0">
                    <v-img :src="offerImageUrlH" max-height="320" max-width="320" @click="preview(true,offerImageUrlH)"></v-img>
                    <v-btn @click="download(offerImageUrlH,'offer' + offerId + 'h.png')" icon><v-icon color="primary">cloud_download</v-icon></v-btn>
                  </td>
                  <td height="290"  style="min-height: 290px;" align="center" v-else>
                  </td>
                </tr>
              </table>
            </center>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col v-if="jsonResult">
        <v-simple-table>
          <tbody>
          <tr v-for="(value, key) in jsonResult" :key="key">
            <td><strong>{{ key }}</strong></td>
            <td v-if="Array.isArray(value)" @click="copyToClipboard(decodeHTMLEntities(value))">
              <div v-for="(item, idx) in value" :key="idx" style="white-space: nowrap;">
                <span>{{ item }}</span>
                <v-icon
                    small
                    @click="copyToClipboard(decodeHTMLEntities(item))"
                    class="ml-2"
                    style="cursor:pointer"
                    title="Kopieren"
                >mdi-content-copy</v-icon>
              </div>
            </td>
            <td v-else-if="isObject(value)">
              <pre>{{ JSON.stringify(value, null, 2) }}</pre>
            </td>
            <td v-else @click="copyToClipboard(decodeHTMLEntities(value))">
              <span v-html="decodeHTMLEntities(value)"></span>
            </td>
          </tr>
          </tbody>
        </v-simple-table>
      </v-col>

    </v-row>
    <v-snackbar
        v-model="snackbar"
        :timeout="2500"
        color="success"
        bottom
        elevation="4"
    >
      <v-icon left class="mr-2">mdi-check-circle</v-icon>
      <span class="font-weight-bold">{{ snackbarText }}</span>
    </v-snackbar>
  </v-container>
</template>

<script>
import Vue from "vue";
import moment from "moment";

export default {
  name: 'PaxConnect',
  components: {},
  data () {
    return {
      activeFrom: new Date().getTime(),
      activeTill: new Date().getTime(),
      offerImageUrlH: null,
      offerImageUrlV: null,
      dialog: false,
      dialogImage: null,
      dialogImageisVertical: false,
      agencyId: null,
      advisoryId: "QAGW-0656",
      snackbar: false,
      snackbarText: 'Daten worden in die Zwischenablage kopiert',
      templateGuid: null,
      officeId: null,
      rectId: null,
      cache: true,
      checkURL: true,
      url: 'https://ds.kermax.tv/#/pc/addImage?offerId=215795196&advisoryId=WDCG-3466&code=e933b1d7e5124b439d722587aca52497',
      offerId: "139852256",
      code: "myCode",
      host: "",
      playlistId: '',
      playlists: [],
      errorResponse: null,
      myParams: '',
      test: null,
      devices: [],
      selectedDevices: [],
      selectedDevicesH: [],
      selectedDevicesV: [],
      devicesH: [],
      devicesV: [],
      doneAdd: false,
      showStage: false,
      doneAddSuccess: false,
      cntPlaylistsAdded: 0,
      addResult: null,
      jsonResult: null,
      till: '2023-10-01T00:00:00',
      formattedDatetime: '01.09.2019',
      formattedDatetimeTill: '01.09.2019',
      provider: 'PAX',
      isBOSIS: false
    }
  },
  methods: {
    copyToClipboard(value) {
      navigator.clipboard.writeText(value.toString());
      this.snackbar = true;
    },
    decodeHTMLEntities: function(text) {
      var textArea = document.createElement('textarea');
      textArea.innerHTML = text;
      return textArea.value;
    },
    onGetResult: function (response) {
      if (!this.isBOSIS) {
        this.agencyId = response.agencyId
      }
      this.till = response.till
      this.offerImageUrlV = Vue.prototype.$config.HOST + "" + response.imageV.replaceAll('public', '') + "?time=" + new Date().getTime()
      this.offerImageUrlH = Vue.prototype.$config.HOST + "" + response.imageH.replaceAll('public', '') + "?time=" + new Date().getTime()
      Vue.prototype.$apiPaxConnect.getOffer({
        advisoryId: this.advisoryId,
        provider: this.provider,
        offerId: this.offerId,
        officeId: this.officeId,
        rectId: this.rectId,
        isChannel: false,
        cache: this.cache,
        templateGuid: this.templateGuid,
        code: this.code
      }, this.onGetResult2)


    },
    onFailedCode: function (response) {
      console.log(response)
      this.errorResponse = response
      // window.open("https://www.kermax.de/paxlounge", "_self")
      return
    },
    isObject: function(val) {
      return val && typeof val === 'object' && !Array.isArray(val);
    },
    checkUrlParamsByUrl: function (url) {
      console.log('checkUrlParamsByUrl', url)
      if (!url || url.length < 10) {
        return
      }
      const params = new URLSearchParams(url.split('?')[1]);
      this.offerId = params.get('offerId') || this.offerId;
      this.advisoryId = params.get('advisoryId') || this.advisoryId;
      this.code = params.get('code') || this.code;
      this.cache = params.get('cache') === '1' ? true : false;

      Vue.prototype.$apiPaxConnect.prepareLogin({
        advisoryId: this.advisoryId,
        provider: this.provider,
        offerId: this.offerId,
        officeId: this.officeId,
        rectId: this.rectId,
        code: this.code
      }, this.onGetLogin, this.onFailedCode)
    },
    onGetLogin: function (response) {
      console.log('onGetLogin', response.agencyId)
      if (!response.company) {
        this.onFailedCode(response)
        return
      }
      this.playlists = response.playlists
      this.devices = response.devices
      this.selectedDevices = []
      this.selectedDevicesH = []
      this.selectedDevicesV = []

      if (this.devices) {
        for (let i in this.devices) {
          this.selectedDevices.push(this.devices[i].guid)
          if (this.devices[i].orientation === 'horizontal') {
            this.devicesV.push(this.devices[i])
            this.selectedDevicesV.push(this.devices[i].guid)
          } else {
            this.devicesH.push(this.devices[i])
            this.selectedDevicesH.push(this.devices[i].guid)
          }
        }
      }
      if (this.playlists && this.playlists.length > 0) {
        this.playlistId = this.playlists[0].guid
      }
      if (this.isBOSIS) {
        if (response.agencyId) {
          this.agencyId = response.agencyId
        }
      }
      if (!this.isBOSIS) {
        try {
          this.activeTill = moment(response.from).toDate()
          this.activeTill = new Date(this.activeTill.getTime() - 1000 * 60 * 60 * 24 * 7)

          const diff = this.activeTill.getTime() - this.activeFrom.getTime();
          const daydiff = diff / (1000 * 60 * 60 * 24);
          if (daydiff < 7) {
            this.activeTill = moment(response.start).toDate()
          }
          this.formattedDatetimeTill = moment(this.activeTill).format("DD.MM.YYYY")
        } catch (e) {
          console.error(e)
        }
      }
      let templateGuid = undefined
      if (response.company && response.company.templateId) {
        templateGuid = response.company.templateId
      }

      if (!templateGuid && response.defaultGuid && response.defaultGuid.length > 0) {
        templateGuid = response.defaultGuid
      }
      this.templateGuid = templateGuid

      Vue.prototype.$apiPaxConnect.requestOfferImage({
        advisoryId: this.advisoryId,
        provider: this.provider,
        offerId: this.offerId,
        officeId: this.officeId,
        rectId: this.rectId,
        isChannel: false,
        cache: this.cache,
        templateGuid: templateGuid,
        code: this.code
      }, this.onGetResult)
    },
    onGetResult2: function (res) {
      this.jsonResult = res
      console.log('onGetResult2', res)
      this.showStage = true
    },
    preview: function (isVertical, url) {
      this.dialogImageisVertical = isVertical
      this.dialogImage = url
      this.dialog = true
      console.log('url', url);
    },
    download: function (url, filename) {
      try {
        fetch(url)
            .then(response => response.blob())
            .then(blob => {
              const link = document.createElement("a");
              link.href = URL.createObjectURL(blob);
              link.download = filename;
              link.click();
            })
            .catch(console.error);
      } catch (e) {
        console.error(e)
      }
    },
    onGetResultAdd: function (response) {
      console.log('onGetResultAdd', response)
      this.doneAdd = true;
      this.addResult = response;
      this.doneAddSuccess = response.listsH.length > 0 || response.listsV.length > 0;
      this.cntPlaylistsAdded = response.listsH.length + response.listsV.length;
    },
    isValidDate: function(d) {
      return d instanceof Date && !isNaN(d);
    },

    removeAddress: function () {
      Vue.prototype.$apiPaxConnect.requestOfferImage({
        advisoryId: this.advisoryId,
        provider: this.provider,
        offerId: this.offerId,
        cache: false,
        officeId: this.officeId,
        rectId: this.rectId,
        isChannel: true,
        templateGuid: this.templateGuid,
        code: this.code
      }, this.onGetResult)
    },
    addOfferId: function (response) {
      console.log('addOfferId', response.image)
      const start = moment(this.formattedDatetime, "DD.MM.YYYY").toDate();
      const end = moment(this.formattedDatetimeTill, "DD.MM.YYYY").toDate();
      const targetTill = moment(this.till, "YYYY-MM-DD").toDate();

      this.dateMessage = ''
      const diffHours = Math.abs(start - end) / 36e5;
      if (diffHours < 12) {
        this.dateMessage = 'Der Abstand zwischen Start und Ende muss mindestens 12 Stunden haben'
        return
      }

      if (!this.isValidDate(start) || this.formattedDatetime.length < 9 || this.formattedDatetime.length > 10)  {
        this.dateMessage = 'Bitte prüfen Sie das Start Datum'
        return
      }
      if (!this.isValidDate(end) || this.formattedDatetimeTill.length < 9 || this.formattedDatetimeTill.length > 10)  {
        this.dateMessage = 'Bitte prüfen Sie das End Datum'
        return
      }


      if (!this.isBOSIS) {
        if (targetTill.getTime() < start.getTime()) {
          this.dateMessage = 'Das Abreisedatum muss größer als das Endatum Angebot sein. ' + moment(targetTill).format("DD.MM.YYYY");
          return
        }
        if (end.getTime() > targetTill.getTime()) {
          this.dateMessage = '"Aktiv bis" darf nicht grösser Abreisedatum sein. ' + moment(targetTill).format("DD.MM.YYYY");
          // Wenn activeTILL ist grösser als Abreisedatum dann activeTill ist Abreisedatum - 7 Tage
          this.formattedDatetimeTill = moment(targetTill).format("DD.MM.YYYY")
          return
        }
      }

      Vue.prototype.$apiPaxConnect.addOfferToOffice({
        start: start.getTime(),
        end: end.getTime(),
        targetDevices: this.selectedDevices,
        provider: this.provider,
        advisoryId: this.advisoryId,
        agencyId: this.agencyId,
        offerId: this.offerId
      }, this.onGetResultAdd)
    },
    toPortal: function() {
      window.location.href = "https://ds.kermax.tv/"
    },
    setDT (a) {
      var d = new Date(a)
      console.log(d.getTime())
    }
  },
  mounted () {
    if (this.$route.query && this.$route.query.advisoryId) {
      this.advisoryId = this.$route.query.advisoryId
    }
    if (this.$route.query && this.$route.query.code) {
      this.code = this.$route.query.code
    }
    if (this.$route.query && this.$route.query.offerId) {
      this.offerId = this.$route.query.offerId
    }
    if (this.$route.query && this.$route.query.provider) {
      this.provider = this.$route.query.provider
    }
    if (this.$route.query && this.$route.query.officeID) {
      this.officeId = this.$route.query.officeID
    }
    if (this.$route.query && this.$route.query.rectID) {
      this.rectId = this.$route.query.rectID
      this.offerId = this.rectId
    }
    if (this.$route.query && this.$route.query.recID) {
      this.rectId = this.$route.query.recID
      this.offerId = this.rectId
    }
    if (this.$route.query && this.$route.query.cache) {
      this.cache = this.$route.query.cache + '' === '1'
    }



    this.myParams = JSON.stringify(this.$route.query)

    this.activeFrom = new Date(new Date().getTime())
    this.activeTill = new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 7) // 7 Tage



    if (window.location.href.indexOf('/#/bs/') > -1) {
      this.activeFrom = new Date(new Date().getTime())
      this.activeTill = new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 14) // 14 Tage
      this.provider = 'BOSIS'
      this.isBOSIS = true
    }
    this.formattedDatetime = moment(this.activeFrom).format("DD.MM.YYYY")
    this.formattedDatetimeTill = moment(this.activeTill).format("DD.MM.YYYY")
    /*
    Vue.prototype.$apiPaxConnect.prepareLogin({
      advisoryId: this.advisoryId,
      provider: this.provider,
      offerId: this.offerId,
      officeId: this.officeId,
      rectId: this.rectId,
      code: this.code
    }, this.onGetLogin, this.onFailedCode)
    */
  }
}
</script>

<style scoped>

</style>
